import { useEffect, useMemo } from 'react'
import { get } from 'lodash'
import { useLazyGetPGUserInfoQuery } from 'api/payment-gateway/paymentGateway'

// Pass the account wherever one is in hand: tenants with business units can run a different
// payment processor per account, so the tenant-level answer is only a fallback.
const usePaymentProvider = (accountId = undefined) => {
  const [getPGUserInfo, { data: pguserInfoData }] = useLazyGetPGUserInfoQuery()
  const isFortis = useMemo(() => get(pguserInfoData, 'userInfo.pgConnectorType') === 'FORTIS', [pguserInfoData])

  useEffect(() => {
    getPGUserInfo(accountId ? { accountId } : {})
  }, [accountId, getPGUserInfo])

  return { isFortis }
}

export default usePaymentProvider
